import { createAction } from 'redux-actions';
import message from '@itt/frontend-scaffold-components/dist/Message/Message';
import {
  RESET,
  SET_BASIC_INFO,
  SET_GROUPS,
  SET_USERS,
  SET_LOADING
} from './actionTypes';
import {
  getPolicyDetails,
  editPolicyBasicInfo,
  assignGroups,
  assignUsers
} from './service';
import STATUS_CODE from '../../../../request/statusCode';
import { INITIAL_BASIC_INFO } from './consts';

const setBasicInfo = createAction(SET_BASIC_INFO);

const setUsers = createAction(SET_USERS);

const setGroups = createAction(SET_GROUPS);

const setLoading = createAction(SET_LOADING);

const reset = createAction(RESET);

const getDetails = ({ name }) => {
  return dispatch => {
    dispatch(setLoading(true));
    return getPolicyDetails({ name }).then(res => {
      dispatch(setLoading(false));
      if (res.statusCode === STATUS_CODE.OK) {
        const {
          name,
          actions,
          condition,
          resource,
          effect,
          description,
          users,
          createdBy,
          createdDate,
          groups
        } = res.data;
        dispatch(
          setBasicInfo({
            name,
            description,
            createdDate,
            createdBy,
            code: JSON.stringify({ actions, resource, condition, effect })
          })
        );
        dispatch(setUsers(users));
        dispatch(setGroups(groups));
        return;
      }
      dispatch(setBasicInfo(INITIAL_BASIC_INFO));
      dispatch(setUsers([]));
      dispatch(setGroups([]));
    });
  };
};

const editBasicInfo = ({ name, description, code }) => {
  return dispatch => {
    return editPolicyBasicInfo({ name, description, code }).then(res => {
      if (res.statusCode === STATUS_CODE.OK) {
        message.success('Policy edited successfully !');
        dispatch(getDetails({ name }));
        return true;
      }
      return false;
    });
  };
};

const editUsers = ({ name, users }) => {
  return dispatch => {
    return assignUsers({ name, users }).then(res => {
      if (res.statusCode === STATUS_CODE.OK) {
        message.success('User updated successfully !');
        dispatch(getDetails({ name }));
        return true;
      }
      return false;
    });
  };
};

const editGroups = ({ name, groups }) => {
  return dispatch => {
    return assignGroups({ name, groups }).then(res => {
      if (res.statusCode === STATUS_CODE.OK) {
        message.success('Group updated successfully !');
        dispatch(getDetails({ name }));
        return true;
      }
      return false;
    });
  };
};

export {
  setBasicInfo,
  setUsers,
  setGroups,
  reset,
  getDetails,
  editBasicInfo,
  editGroups,
  editUsers,
  setLoading
};
